import { getResizedImageUrl } from "@/utils/common";
import React from "react";

interface IV2AvatarProps {
  value?: string | null;
  width?: number;
  height?: number;
  size?: number;
}

const V2Avatar: React.FC<IV2AvatarProps> = ({
  value,
  width = 30,
  height = 30,
  size = 30,
}) => {
  const defaultImageUrl = "/v2-icon/default-avatar.svg"; // 수정: 스페이스 제거

  const avatarStyle = {
    width: `${width}px`,
    height: `${height}px`,
    borderRadius: "50%",
  };

  const handleImageError = (
    e: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    e.currentTarget.src = defaultImageUrl;
  };

  return (
    <img
      style={avatarStyle}
      onError={handleImageError}
      src={getResizedImageUrl(value, `${size * 2}x${size * 2}`)}
      alt="avatar"
      draggable={false}
    />
  );
};

export default V2Avatar;
